<div class="auto-suggest-div">
  <p class="zs-action-field" [ngStyle]="selectCustomStyle">
    @if (label) {
      <label class="auto-suggest-label">{{label}}</label>
    }
    <span class="zs-input-icon zs-icon-carat-down zs-interactive-secondary auto-suggest-span" [ngStyle]="selectCustomStyle">
      <input type="text" class="auto-suggest-field" [(ngModel)]="selected"
        (input)="onTextChange($event.target.value)" [placeholder]="emptyValue" (blur)="blurEvent()"
        [ngStyle]="selectCustomStyle" [ngClass]="touched ? inputClass : ''">
        @if (displayMenu && dataSource) {
          <ul #menu class="zs-menu auto-suggest-menu" (changed)="menuOpened()">
            @if ({value: (dataSource
              | filterTable : ['displayLabel'] : this.searchText : false
              )}; as filterData;) {
              @for (menu of filterData?.value; track menu) {
                <li (mousedown)="selectValueFromMenu(menu)">
                  <span [innerHtml]="this.getDisplayLabel(menu['displayLabel'])"></span>
                </li>
              }
            }
          </ul>
        }
      </span>
    </p>
    @if (isInErrorState) {
      <span [ngStyle]="selectCustomStyle" class="zs-message zs-error auto-suggest-error">{{errorMessage}}</span>
    }
  </div>